export function getNow() {
  if (Object.prototype.hasOwnProperty.call(window, 'performance')) {
    return window.performance.now();
  }
  return Date.now();
}
